import HttpService from "./htttp.service";

class UserService {
  // authEndpoint = process.env.API_URL;

  getUsers = async (page, pageSize, sortColumn, sortColumnValue, searchValue, role) => {
    let fetchUrl = "users";
    if (page && pageSize && sortColumn && sortColumnValue) {
      fetchUrl = `users?page=${page}&per_page=${pageSize}&sort_column=${
        sortColumn
      }&sort_column_value=${sortColumnValue}&search_value=${encodeURIComponent(searchValue)}`;
    } else if (role) {
      fetchUrl = `users?role=${role}`;
    }
    return await HttpService.get(fetchUrl);
  };

  addUser = async (data) => {
    const fetchUrl = "users";
    return await HttpService.post(fetchUrl, data);
  };

  deleteUser = async (id) => {
    const fetchUrl = `users/${id}`;
    return await HttpService.delete(fetchUrl);
  };

  updateUserStatus = async (id, data) => {
    const fetchUrl = `users/${id}`;
    return await HttpService.patch(fetchUrl, data);
  };

  showUser = async (id) => {
    const fetchUrl = `users/${id}`;
    return await HttpService.get(fetchUrl);
  };

  updateUser = async (id, data) => {
    const fetchUrl = `users/${id}`;
    return await HttpService.put(fetchUrl, data);
  };

  getUserPermissions = async (id) => {
    const fetchUrl = `user_permissions?id=${id}`;
    return await HttpService.get(fetchUrl);
  };

  addUserPermissions = async (data) => {
    const fetchUrl = "user_permissions";
    return await HttpService.post(fetchUrl, data);
  };

  updateUserPermissions = async (id, data) => {
    const fetchUrl = `user_permissions/${id}`;
    return await HttpService.put(fetchUrl, data);
  };

  deleteAllUserPermission = async (user_id) => {
    const fetchUrl = `user_permissions?user_id=${user_id}`;
    return await HttpService.delete(fetchUrl);
  };
}

export default new UserService();
